import { gql } from '@apollo/client'
import { AUDIT_QUESTION_FRAGMENT } from '../fragments'

export const UPDATE_AUDIT_QUESTIONS = gql`
  mutation UpdateAuditQuestions($input: UpdateAuditQuestionsInput!) {
    updateAuditQuestions(input: $input) {
      auditQuestions {
        ...AuditQuestion
      }
    }
  }
  ${AUDIT_QUESTION_FRAGMENT}
`
